export const cards = [
    '00-TheFool',
    '01-TheMagician',
    '02-TheHighPriestess',
    '03-TheEmpress',
    '04-TheEmperor',
    '05-TheHierophant',
    '06-TheLovers',
    '07-TheChariot',
    '08-Strength',
    '09-TheHermit',
    '10-WheelOfFortune',
    '11-Justice',
    '12-TheHangedMan',
    '13-Death',
    '14-Temperance',
    '15-TheDevil',
    '16-TheTower',
    '17-TheStar',
    '18-TheMoon',
    '19-TheSun',
    '20-Judgement',
    '21-TheWorld',
];
export const cardsName = {
    '00-TheFool':          '愚者',
    '01-TheMagician':      '魔術師',
    '02-TheHighPriestess': '女教皇',
    '03-TheEmpress':       '女帝',
    '04-TheEmperor':       '皇帝',
    '05-TheHierophant':    '法王',
    '06-TheLovers':        '恋人',
    '07-TheChariot':       '戦車',
    '08-Strength':         '力',
    '09-TheHermit':        '隠者',
    '10-WheelOfFortune':   '運命の輪',
    '11-Justice':          '正義',
    '12-TheHangedMan':     '吊るされた男',
    '13-Death':            '死神',
    '14-Temperance':       '節制',
    '15-TheDevil':         '悪魔',
    '16-TheTower':         '塔',
    '17-TheStar':          '星',
    '18-TheMoon':          '月',
    '19-TheSun':           '太陽',
    '20-Judgement':        '審判',
    '21-TheWorld':         '世界',
};
export const cardDirection = {upright: '正位置', reverse: '逆位置'};
export const cardsText = {upright: {}, reverse: {}};

//------------------------------------------------------------
// #### 00 愚者 正位置: 極端な自由
cardsText.upright['00-TheFool'] = [
'「愚者」の正位置は、あなたに自由な精神と無限の可能性をもたらします。周りの常識に囚われず、自分の直感を信じて行動することが幸運を呼び込むでしょう。しかし、自由には責任が伴うことも忘れないでください。無計画な冒険は魅力的ですが、多少のリスクを考慮することで、大きな成功へと繋がるかもしれません。新しい挑戦に前向きになれる日です。',
];

// #### 00 愚者 逆位置: 見切り発車
cardsText.reverse['00-TheFool'] = [
'「愚者」の逆位置は、見切り発車や無謀な行動への警告です。計画性が欠けたまま突き進むと、思わぬトラブルに巻き込まれる可能性があります。自分の行動が本当に正しいか、もう一度冷静に見直すことが必要です。気持ちは高ぶっているかもしれませんが、今は慎重な判断が求められる日です。焦らず確実な一歩を心がけましょう。',
];

//------------------------------------------------------------
// #### 01 魔術師 正位置: 成功への期待
cardsText.upright['01-TheMagician'] = [
'「魔術師」の正位置は、成功と新しい可能性の到来を示します。あなたの創造力やコミュニケーション能力が高まり、目の前にあるチャンスを活かすための知識と技術が揃っている時期です。自身のアイデアやスキルを積極的に使って、目標達成に向けて動き出しましょう。周りのサポートも得やすく、物事がスムーズに進むでしょう。',
];

// #### 01 魔術師 逆位置: 能力の不足
cardsText.reverse['01-TheMagician'] = [
'「魔術師」の逆位置は、力不足や準備不足による失敗の兆しを示します。何かに挑戦しようとしても、十分な知識やスキルが伴わないため、思うように結果を出せないかもしれません。今は無理に行動せず、必要な準備や情報収集に時間を割くことが大切です。焦らず基礎を固めることで、後々の成功に繋がります。',
];

//------------------------------------------------------------
// #### 02 女教皇 正位置: 精神の強さ
cardsText.upright['02-TheHighPriestess'] = [
'「女教皇」の正位置は、精神的な強さと直感力の向上を示します。冷静かつ洞察力を持って状況を判断することができ、感情に流されずに正しい選択ができる日です。また、他者との調和を大切にしつつも、自分自身の内なる声に耳を傾けることが鍵となります。知識や直感を活かして、賢明な決断を下すことができるでしょう。',
];

// #### 02 女教皇 逆位置: 身勝手さ
cardsText.reverse['02-TheHighPriestess'] = [
'「女教皇」の逆位置は、自己中心的な思考や感情に振り回されることを示唆しています。他人への配慮が欠け、自分勝手な行動を取ってしまいがちな日です。そのため、周囲との衝突や誤解が生じるかもしれません。冷静さを取り戻し、感情に流されずに理性的な判断を心がけることが、トラブルを避けるために重要です。',
];

//------------------------------------------------------------
// ### 03 女帝 正位置: 豊かさや愛情
cardsText.upright['03-TheEmpress'] = [
'「女帝」の正位置は、豊かな愛情と物質的な豊かさがもたらされることを示します。特に人間関係において、温かい気持ちや支え合いが強まる一日になるでしょう。新しい創造的なアイデアやプロジェクトが実を結び、成功する兆しも見えています。感謝の気持ちを持ち、愛する人々との時間を大切にすることで、さらに大きな幸福感を得られます。穏やかな幸せが、あなたの心を満たす日になるでしょう。',
];

// ### 03 女帝 逆位置: 挫折や虚栄
cardsText.reverse['03-TheEmpress'] = [
'「女帝」の逆位置は、自信過剰や虚栄心が災いを招く兆しを示します。過剰な期待や自己中心的な態度が、周囲との摩擦を生む可能性があります。物事が思うように進まないと感じるかもしれませんが、それは自分自身に対する過度な欲求が原因かもしれません。今日のテーマは謙虚さです。内面の成長を意識し、他人への配慮を忘れずに行動しましょう。',
];

//------------------------------------------------------------＾
// ### 04 皇帝 正位置: 自立や統率力
cardsText.upright['04-TheEmperor'] = [
'「皇帝」の正位置は、リーダーシップと自立心が強調されることを示します。あなたは自身の目標に対して明確なビジョンを持ち、決断力と責任感を発揮できる一日です。職場や家庭での統率力を発揮し、周囲の人々を導くことが求められるでしょう。また、自分の意思を強く持ち、他者に流されない姿勢が重要です。今日のあなたは頼れる存在として評価されるでしょう。',
];

// ### 04 皇帝 逆位置: 傲慢や無責任
cardsText.reverse['04-TheEmperor'] = [
'「皇帝」の逆位置は、リーダーシップの欠如や無責任さが目立つ兆しを示します。自分の意見を押し通すあまり、他者の意見を無視したり、独裁的な振る舞いをしてしまう可能性があります。結果として、周囲との関係が悪化し、協力を得られない状況に陥るかもしれません。今日は謙虚さと他者への配慮を忘れず、調和を保つよう心がけることが大切です。',
];

//------------------------------------------------------------＾
// ### 05 法王 正位置: 慈悲や協調性
cardsText.upright['05-TheHierophant'] = [
'「法王」の正位置は、慈悲と協調がカギとなることを示します。あなたは周囲の人々と強い信頼関係を築くことができ、困難な状況でも助け合いの精神で乗り越えることができるでしょう。特に、家族や友人、職場の同僚といった人々との関わりが重要になります。コミュニケーションが円滑に進み、互いに支え合うことができる日です。精神的な成長や内面的な充実感も得られるでしょう。',
];

// ### 05 法王 逆位置: 非常識や閉塞感
cardsText.reverse['05-TheHierophant'] = [
'「法王」の逆位置は、閉塞感や非常識な行動によるトラブルの兆しを示します。周囲との関係がぎくしゃくし、助け合いが難しい状況になるかもしれません。自分の意見や価値観を押し付けてしまうことで、孤立してしまう恐れもあります。今は強引に物事を進めるよりも、冷静に状況を見つめ、柔軟な対応を心がけるべきです。周りとの調和を大切にし、自己主張を控えることで問題を回避できるでしょう。',
];

//------------------------------------------------------------＾
// ### 06 恋人 正位置: 愛情や幸福
cardsText.upright['06-TheLovers'] = [
'「恋人」の正位置は、愛情と幸福に満ちた一日を予感させます。恋愛関係においては、相手との絆が深まり、穏やかな幸福感に包まれるでしょう。また、友情や家族関係でも愛情が深まり、楽しい時間を過ごせる日です。重要な選択を迫られる場面でも、あなたの心が導く正しい道を選ぶことができるでしょう。愛や調和が今日のテーマとなり、幸せな一日が訪れます。',
];

// ### 06 恋人 逆位置: 浮気や衝突
cardsText.reverse['06-TheLovers'] = [
'「恋人」の逆位置は、不和や衝突、場合によっては裏切りの兆しを示します。恋愛関係において誤解やすれ違いが生じやすく、お互いの気持ちが離れてしまう可能性があります。また、感情に流されて不適切な選択をしてしまうことも考えられます。重要な決断は慎重に行い、自分の本心と向き合う時間を持つことが必要です。誠実さと冷静さを保つことが、今日の課題です。',
];

//------------------------------------------------------------＾
// ### 07 戦車 正位置: 勝利や前進
cardsText.upright['07-TheChariot'] = [
'「戦車」の正位置は、勝利と前進を象徴します。あなたは強い意志と行動力で目標に向かって突き進むことができ、成功を手に入れることができるでしょう。困難な状況にも果敢に立ち向かい、自信を持って前進できる日です。自分自身の力を信じ、積極的に行動することで、良い結果を引き寄せることができるでしょう。今日は、大きな達成感を得られる一日となるでしょう。',
];

// ### 07 戦車 逆位置: 暴走や挑発
cardsText.reverse['07-TheChariot'] = [
'「戦車」の逆位置は、コントロールを失った暴走や感情的な挑発を示しています。無理に物事を進めようとすることで、思わぬトラブルに巻き込まれる可能性があります。また、他者との対立が激化しやすく、感情的な争いが生じるかもしれません。今日は冷静さを保ち、慎重な行動を心がけることが重要です。無理に押し進めるよりも、立ち止まって状況を見直すことが大切です。',
];

//------------------------------------------------------------＾
// ### 08 力 正位置: 勇気や強さ
cardsText.upright['08-Strength'] = [
'「力」の正位置は、あなたの内なる強さと勇気を象徴します。困難な状況に直面しても、あなたは冷静さと自信を持って対処することができるでしょう。精神的な強さが際立ち、周囲の人々にも安心感を与えます。感情に流されず、理性的に判断することで成功を手に入れられる日です。また、あなたの思いやりや優しさが、他人との関係を深めることにもつながるでしょう。',
];

// ### 08 力 逆位置: 臆病や強引
cardsText.reverse['08-Strength'] = [
'「力」の逆位置は、自信の欠如や臆病な心が強調される兆しを示します。物事に対して過度に恐れや不安を抱き、積極的に行動できない状況が生じるかもしれません。逆に、強引に物事を進めようとして無理をしてしまう可能性もあります。冷静さを欠き、感情的になると失敗しやすい日です。今日は少しペースを落とし、自分の感情や行動を慎重に見つめ直すことが大切です。',
];

//------------------------------------------------------------＾
// ### 09 隠者 正位置: 充足や思慮深さ
cardsText.upright['09-TheHermit'] = [
'「隠者」の正位置は、内省と深い洞察が重要なことを表しています。外の世界よりも、自分の内側に目を向けて、自分の感情や思考を整理する時間を持つことで、精神的な充足感が得られるでしょう。独りで静かに考えることで、物事の本質を見抜く力が増し、今後の計画をより確実に進められるようになります。焦らず、時間をかけて自己成長を意識しましょう。',
];

// ### 09 隠者 逆位置: 内向的や邪推
cardsText.reverse['09-TheHermit'] = [
'「隠者」の逆位置は、過度な内向性や他人への不信感が強まる兆しを示しています。自分の殻に閉じこもりすぎて、外の世界とのつながりを断ってしまう恐れがあります。思い込みや不安に囚われ、他人を疑ったり、状況を悲観的に見てしまうかもしれません。今日は少し視野を広げ、他者との対話や関わりを意識してみると、状況を改善する助けとなるでしょう。',
];

//------------------------------------------------------------＾
// ### 10 運命の輪 正位置: 好機や上昇
cardsText.upright['10-WheelOfFortune'] = [
'「運命の輪」の正位置は、運命的なチャンスや幸運が訪れることを示しています。あなたの人生において重要な転換点がやってきており、物事が良い方向に進み始めるでしょう。運命の流れに身を任せ、直感的な判断が成功のカギとなります。特に予期せぬ幸運やチャンスに恵まれる可能性が高い日です。勇気を持ってそのチャンスを掴むことで、大きな成果が得られるでしょう。',
];

// ### 10 運命の輪 逆位置: 誤算や災難
cardsText.reverse['10-WheelOfFortune'] = [
'「運命の輪」の逆位置は、予期しないトラブルや誤算が生じやすい兆しを示しています。運気が一時的に低迷し、計画していたことが思わぬ形で崩れてしまう可能性があります。しかし、これも一時的な運命のサイクルであり、焦らずに対応することが大切です。状況が悪化する前に柔軟に対処し、問題を長引かせないための慎重な判断が求められる日となるでしょう。',
];

//------------------------------------------------------------＾
// ### 11 正義 正位置: 公平や正義
cardsText.upright['11-Justice'] = [
'「正義」の正位置は、公正な判断とバランスが重要なことを象徴します。物事を公平に捉え、冷静な分析に基づいて行動することが成功の鍵となります。今日あなたは倫理的な選択を迫られる場面に直面するかもしれませんが、その際には自分の価値観を大切にし、他者に対しても誠実であることが求められます。感情に流されることなく、理性的な決断が評価され、信頼を得る日になるでしょう。',
];

// ### 11 正義 逆位置: 不正や二股
cardsText.reverse['11-Justice'] = [
'「正義」の逆位置は、不正や不公平が表面化する兆しを示しています。道徳的なジレンマや、人間関係において誤解や対立が生じやすい日です。二股や裏切りといった不誠実な行動が原因で信頼を失う危険性もあります。また、自分自身が不公正な扱いを受ける可能性もあり、感情的にならず冷静に対処することが求められます。真実を見失わず、公平な目で状況を見つめ直しましょう。',
];

//------------------------------------------------------------＾
// ### 12 吊るされた男 正位置: 忍耐や試練
cardsText.upright['12-TheHangedMan'] = [
'「吊るされた男」の正位置は、忍耐が試されることを示しています。今は焦って行動するよりも、状況を受け入れ、じっくりと待つことが重要です。自分がコントロールできない事柄に対して無理をせず、時には犠牲を払うことで長期的な成功に繋がるでしょう。この試練はあなたに成長を促すものであり、困難な時期が過ぎ去った後には新たな視点が得られるはずです。',
];

// ### 12 吊るされた男 逆位置: 挫折や徒労
cardsText.reverse['12-TheHangedMan'] = [
'「吊るされた男」の逆位置は、挫折感や徒労感が強まる兆しを示します。努力しても結果が見えず、何をしても無駄に感じる瞬間があるかもしれません。特に、自分の犠牲が報われないように感じると、フラストレーションが溜まる可能性があります。無理をして進もうとせず、一度立ち止まって状況を見つめ直すことが大切です。時には諦めることも前進のための一歩となるでしょう。',
];

//------------------------------------------------------------＾
// ### 13 死神 正位置: 損失や死
cardsText.upright['13-Death'] = [
'「死神」の正位置は、大きな変化や終焉を象徴します。何かが終わりを迎えることで新たな始まりが訪れる日です。この変化は一見ネガティブに感じられるかもしれませんが、古いものを手放すことで新しいチャンスが生まれることを意味しています。過去を引きずらず、前向きに新しい未来を迎える準備をすることが必要です。感情的な整理を行い、未来へのステップを踏み出しましょう。',
];

// ### 13 死神 逆位置: 停滞や再開
cardsText.reverse['13-Death'] = [
'「死神」の逆位置は、停滞感や過去への未練が強調される兆しを示します。物事がうまく進まず、過去に執着していると感じるかもしれません。特に終わりにしたはずの問題が再び浮上し、解決を迫られることがあるでしょう。何かを断ち切ることが難しくても、前進するためにはそれが必要です。今日は勇気を持って過去を手放し、未来に向けて進む準備をしましょう。',
];

//------------------------------------------------------------＾
// ### 14 節制 正位置: 安定や協力
cardsText.upright['14-Temperance'] = [
'「節制」の正位置は、調和とバランスが鍵となることを示しています。仕事やプライベートの場面で他者との協力が円滑に進み、心身ともに安定した状態を保つことができるでしょう。無理をせず、穏やかなペースで物事を進めることが成功のポイントです。また、感情をコントロールし、冷静な対応を心がけることで、周囲との関係も円滑に進むでしょう。',
];

// ### 14 節制 逆位置: 不安定や怠惰
cardsText.reverse['14-Temperance'] = [
'「節制」の逆位置は、バランスの欠如や不安定さが際立つことを示しています。感情のコントロールが難しくなり、何事にも集中できない状況が生まれるかもしれません。また、怠惰な態度や過度なストレスが原因で、自分のペースを見失う恐れがあります。今日は、自分のエネルギーを無駄にしないように意識し、冷静さを取り戻すことが大切です。',
];

//------------------------------------------------------------＾
// ### 15 悪魔 正位置: 誘惑や裏切り
cardsText.upright['15-TheDevil'] = [
'「悪魔」の正位置は、誘惑や束縛に注意が必要なことを示しています。欲望や誘惑が強くなり、何かに依存してしまう危険性があります。特に、他者との関係で裏切りや不誠実な行動に直面する可能性があるため、注意が必要です。自分の欲望を冷静に見つめ直し、感情に流されることなく理性的な判断を心がけることが大切です。誘惑に打ち勝つ強さが試される日となるでしょう。',
];

// ### 15 悪魔 逆位置: 解放や回復
cardsText.reverse['15-TheDevil'] = [
'「悪魔」の逆位置は、過去の束縛や依存から解放される兆しを示しています。これまで抑えられていた自由や自分らしさを取り戻すことができ、精神的な回復を感じる日となるでしょう。特に、ネガティブな影響を与えていた環境や人間関係から離れる決断を下すことが、前向きな変化をもたらすでしょう。過去の誘惑や習慣に縛られず、自分の成長と前進を選び取る日です。',
];

//------------------------------------------------------------＾
// ### 16 塔 正位置: 崩壊や悲劇
cardsText.upright['16-TheTower'] = [
'「塔」の正位置は、突然の変化やショックが訪れることを示唆しています。今まで築いてきたものが予期せぬ出来事により崩壊する可能性があります。このような変化は一時的には困難に思えるかもしれませんが、新しい始まりを促すためのプロセスでもあります。今日の出来事はあなたにとって試練となりますが、これを乗り越えることで新たな成長が待っています。感情的に揺さぶられる日かもしれませんが、冷静さを保つことが求められます。',
];

// ### 16 塔 逆位置: 誤解や揉め事
cardsText.reverse['16-TheTower'] = [
'「塔」の逆位置は、誤解や些細な問題が引き起こすトラブルが発生する兆しを示しています。大きな崩壊や劇的な変化は回避できるかもしれませんが、小さな衝突や誤解が原因で人間関係や仕事において不協和音が生じる可能性があります。状況を改善するためには、慎重なコミュニケーションと冷静な対応が必要です。今日は軽率な行動を避け、問題が大きくなる前に解決に努めることが重要です。',
];

//------------------------------------------------------------＾
// ### 17 星 正位置: 希望や可能性
cardsText.upright['17-TheStar'] = [
'「星」の正位置は、希望と新たな可能性が広がることを象徴しています。過去の苦難を乗り越え、新しい未来への道が開けるでしょう。特に、目標に向かって努力していることが実を結び、あなたの夢やビジョンが現実に近づく予感がします。今日のあなたは心が落ち着いており、周囲の人々にも良い影響を与えることができるでしょう。自分自身を信じ、希望を胸に抱いて前進する日となります。',
];

// ### 17 星 逆位置: 失望や諦念
cardsText.reverse['17-TheStar'] = [
'「星」の逆位置は、失望や挫折を感じやすいことを示しています。計画が思うように進まず、目標が遠のいたように感じるかもしれません。自分の能力や未来に対して自信を失い、諦めたい気持ちが湧いてくる可能性があります。しかし、この時期は一時的なものであり、諦めずにもう一度立ち上がることが大切です。小さな希望を見つけ、それに集中することで再び前進できるでしょう。',
];

//------------------------------------------------------------＾
// ### 18 月 正位置: 危険や誘惑
cardsText.upright['18-TheMoon'] = [
'「月」の正位置は、不確実性と疑念が強まることを示しています。直感が冴えている一方で、見えない危険や誘惑に注意が必要です。何かが隠されているかのような不安感が募り、感情が揺れ動く可能性があります。特に人間関係やビジネスにおいて、曖昧な状況が生まれやすいでしょう。今日は慎重な判断を心がけ、直感に頼りすぎず冷静な思考を取り戻すことが必要です。',
];

// ### 18 月 逆位置: 変化や失敗
cardsText.reverse['18-TheMoon'] = [
'「月」の逆位置は、隠された問題が表面化し、変化が訪れる兆しを示しています。何かを見逃していたり、誤解が生じていたことに気付くことがあり、それが原因で一時的な失敗や混乱が生じる可能性があります。しかし、この変化は必ずしも悪いものではなく、問題を解決するためのチャンスと捉えることができます。恐れずに状況に立ち向かい、解決策を見つけるために行動することが大切です。',
];

//------------------------------------------------------------＾
// ### 19 太陽 正位置: 成功や活気  
cardsText.upright['19-TheSun'] = [
'「太陽」の正位置は、輝かしい成功とエネルギーの充実を象徴しています。今日は前向きな気持ちで満たされ、目標に向かって順調に進む日となるでしょう。困難だった状況も解決に向かい、周囲の人々からの信頼や評価も得られる時です。また、健康運も高まり、身体的にも精神的にもエネルギーが溢れています。この好調な波に乗り、自信を持って行動することで、さらなる成果を手にすることができるでしょう。',
];

// ### 19 太陽 逆位置: 衰退や落胆  
cardsText.reverse['19-TheSun'] = [
'「太陽」の逆位置は、一時的な挫折や失望が訪れる可能性を示唆しています。期待していた結果が得られず、達成感を感じにくい日かもしれません。計画が思うように進まないことで、自信を失いがちになりますが、焦らずに状況を見直すことが重要です。また、過信や自信過剰が裏目に出ることもあるため、謙虚な態度を忘れないよう心がけましょう。落胆しても、それは一時的なものであり、冷静さを取り戻せば再び道が開けます。',
];

//------------------------------------------------------------＾
// ### 20 審判 正位置: 復活や更新  
cardsText.upright['20-Judgement'] = [
'「審判」の正位置は、大きな再生と新たな始まりを象徴しています。過去に閉じられていた道や機会が再び開かれ、重要な選択や決断が求められるでしょう。これまでの努力や試練が報われる瞬間が訪れ、長らく停滞していた状況が一気に動き出す予感があります。今日のあなたは新しい視点で物事を捉え、古い習慣や考え方を刷新するチャンスを迎えています。積極的に新しい可能性を受け入れることで、成功を手にすることができるでしょう。',
];

// ### 20 審判 逆位置: 手詰まりや未練  
cardsText.reverse['20-Judgement'] = [
'「審判」の逆位置は、過去に執着し、新しい展開が阻害されることを示しています。何かに対して未練が残り、前に進むことが難しいと感じるかもしれません。また、自分の過去の過ちや失敗に対する後悔が強まり、未来への展望を閉ざしてしまう可能性もあります。手詰まり感が強い状況にあるため、過去を振り返るのではなく、新しい道を模索する勇気が必要です。現実と向き合い、今をしっかりと生きることで未来への突破口が見えてくるでしょう。',
];

//------------------------------------------------------------＾
// ### 21 世界 正位置: 完全や完成  
cardsText.upright['21-TheWorld'] = [
'「世界」の正位置は、一つのサイクルの完成と満足感を象徴しています。あなたが長らく取り組んできたことがようやく結実し、達成感に満たされる日となるでしょう。目標に向かっての道のりが完了し、新たな段階への準備が整います。今日はあなたの努力が報われ、周囲からの評価も高まります。心からの充足感を味わい、自分の成功を祝福してください。そして、次のステップに進むためのエネルギーを蓄える日となるでしょう。',
];

// ### 21 世界 逆位置: 不完全や崩壊  
cardsText.reverse['21-TheWorld'] = [
'「世界」の逆位置は、完了しきれない状況や未完成のプロジェクトを示唆しています。目標達成まであと一歩のところで障害にぶつかり、計画が中断する可能性があります。期待していた結果が得られず、不満や焦りを感じることもあるでしょう。しかし、これは終わりではなく、改めて戦略を見直す必要があるというサインです。今日は現状を再評価し、今後の計画を練り直すことが重要です。焦らずにもう一度軌道修正を行いましょう。',
];

//------------------------------------------------------------
// Test: exist data
const test = function() {
    const table = cards.map((card, i) => {
        const name = cardsName[card];
        const upright = cardsText.upright[card].length;
        const reverse = cardsText.reverse[card].length;
        return {card, name, upright, reverse};
    });
    console.table(table);
};
//test();
